/* Paper Straight — jubileumweek: gratis Polishing Brush
 * Voegt het cadeauproduct van EUR 0,00 toe zodra er iets anders in de winkelwagen ligt,
 * en haalt hem er weer uit als de wagen leeg raakt of het venster voorbij is.
 * Testen kan buiten het venster met ?ps_gift=1 in de URL.
 * Faalt altijd stil: een fout mag nooit het afrekenen blokkeren.
 */
(function () {
  'use strict';

  var CADEAU_VARIANT = 61193557147982;
  var CADEAU_HANDLE = 'polishing-brush-birthday-gift';

  // venster: vrijdag 16-10 09:00 CEST t/m zaterdag 24-10 06:00 CEST (stil verlengd t/m vrijdag VS, gelijk met BDAY20)
  var START = Date.UTC(2026, 9, 16, 7, 0, 0);
  var EINDE = Date.UTC(2026, 9, 24, 4, 0, 0);

  var bezig = false;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var testStand = /[?&]ps_gift=1/.test(window.location.search);

  if (testStand) {
    try { window.sessionStorage.setItem('psGiftTest', '1'); } catch (e) {}
  }
  function testAan() {
    if (testStand) return true;
    try { return window.sessionStorage.getItem('psGiftTest') === '1'; } catch (e) { return false; }
  }

  function binnenVenster() {
    if (testAan()) return true;
    var nu = Date.now();
    return nu >= START && nu < EINDE;
  }

  function sectieId() {
    var el = document.querySelector('[id^="shopify-section-"][id*="cart-drawer"]');
    return el ? el.id.replace('shopify-section-', '') : null;
  }

  function vervangSectie(sections, id) {
    if (!sections || !id || !sections[id]) return;
    var houder = document.getElementById('shopify-section-' + id);
    if (!houder) return;
    var nieuw = new DOMParser().parseFromString(sections[id], 'text/html')
      .querySelector('#shopify-section-' + id);
    if (nieuw) houder.replaceWith(nieuw);
  }

  function isCadeau(item) {
    return item.variant_id === CADEAU_VARIANT || item.id === CADEAU_VARIANT;
  }

  function haalCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  /* Werkt zowel in de cart drawer als op de winkelwagenpagina:
     verbergt aantal- en verwijderknoppen en zet er een FREE-label bij. */
  function markeer() {
    var links = document.querySelectorAll('a[href*="' + CADEAU_HANDLE + '"]');
    Array.prototype.forEach.call(links, function (link) {
      // de zichtbare winkelwagen is een app (content.9gtb.com, klassen ast-cart__*); daarna de themaregels
      var regel = link.closest('.ast-cart__item') || link.closest('li, tr, [class*="line-item"], [class*="cart-item"]');
      if (!regel || regel.getAttribute('data-ps-cadeau') === 'true') return;
      regel.setAttribute('data-ps-cadeau', 'true');

      var weg = regel.querySelectorAll(
        'quantity-selector, [class*="quantity"], button[name="minus"], button[name="plus"],' +
        ' a[href*="/cart/change"], cart-remove-button, [class*="remove"]'
      );
      Array.prototype.forEach.call(weg, function (k) { k.style.setProperty('display', 'none', 'important'); });

      if (regel.querySelector('[data-ps-badge]')) return;
      var badge = document.createElement('span');
      badge.setAttribute('data-ps-badge', '1');
      var taal = ((window.Shopify && window.Shopify.locale) || 'en').slice(0, 2);
      badge.textContent = { de: 'GRATIS · GESCHENK', da: 'GRATIS · GAVE', fr: 'OFFERT · CADEAU' }[taal] || 'FREE · BIRTHDAY GIFT';
      badge.setAttribute('style',
        'display:inline-block;align-self:flex-start;width:fit-content;margin-top:6px;padding:3px 8px;font-size:11px;font-weight:700;' +
        'letter-spacing:1px;background:#443326;color:#ede9e3;white-space:nowrap;');
      var titel = Array.prototype.filter.call(regel.querySelectorAll('a[href*="' + CADEAU_HANDLE + '"]'), function (a) {
        return !a.querySelector('img') && a.textContent.trim() !== '';
      })[0] || link;
      titel.parentNode.insertBefore(badge, titel.nextSibling);
    });
  }

  function sync() {
    if (bezig) return Promise.resolve();
    bezig = true;

    return haalCart().then(function (cart) {
      var cadeau = null;
      var rest = [];
      cart.items.forEach(function (i) { if (isCadeau(i)) { cadeau = i; } else { rest.push(i); } });

      var sec = sectieId();
      var moetErin = binnenVenster() && rest.length > 0 && !cadeau;
      var moetEruit = cadeau && (rest.length === 0 || !binnenVenster());
      var teveel = cadeau && cadeau.quantity > 1;

      if (moetErin) {
        var fd = new FormData();
        fd.append('id', String(CADEAU_VARIANT));
        fd.append('quantity', '1');
        if (sec) { fd.append('sections', sec); fd.append('sections_url', window.location.pathname); }
        return fetch(root + 'cart/add.js', { method: 'POST', body: fd })
          .then(function (r) { return r.json(); })
          .then(function (d) { vervangSectie(d.sections, sec); });
      }

      if (moetEruit || teveel) {
        var body = { id: cadeau.key, quantity: teveel && !moetEruit ? 1 : 0 };
        if (sec) { body.sections = sec; body.sections_url = window.location.pathname; }
        return fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        }).then(function (r) { return r.json(); })
          .then(function (d) { vervangSectie(d.sections, sec); });
      }

      return null;
    }).catch(function () {
      // bewust stil
    }).then(function () {
      bezig = false;
      setTimeout(markeer, 80);
      setTimeout(markeer, 600);
    });
  }

  var appStand = '';
  var appGezien = false;
  var appTimer = null;
  function appRegels() {
    var regels = document.querySelectorAll('.ast-cart__item');
    return Array.prototype.map.call(regels, function (r) {
      var t = r.querySelector('.ast-cart__item__title');
      var q = r.querySelector('.ast-cart__item__quantity input, .ast-cart__item__quantity [class*="value"]');
      return (t ? t.textContent.trim() : '') + ':' + (q ? (q.value || q.textContent || '').trim() : '');
    }).join('|');
  }
  try {
    new MutationObserver(function () {
      clearTimeout(appTimer);
      appTimer = setTimeout(function () {
        markeer();
        var stand = appRegels();
        if (!appGezien) {
          appGezien = true;
          appStand = stand;
        } else if (stand !== appStand) {
          appStand = stand;
          sync();
        }
      }, 300);
    }).observe(document.body, { childList: true, subtree: true });
  } catch (e) {}

  document.addEventListener('cart:change', function () { setTimeout(sync, 60); });
  document.addEventListener('cart:refresh', function () { setTimeout(sync, 60); });
  document.addEventListener('DOMContentLoaded', function () { setTimeout(sync, 400); });
  if (document.readyState !== 'loading') setTimeout(sync, 400);

  window.psBirthdayGift = { sync: sync, markeer: markeer, binnenVenster: binnenVenster, variant: CADEAU_VARIANT };
})();
